import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NotificationToastService } from '../../../../services/notification-toast.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MenuService } from '../../../../services/menu.service';
import { CashDeskService } from '../../../../services/cash-desk.service'; 
import { ValidateAutoCompleteSelect } from '../../../../validators/autocomplete-select.validator';
import { FilterCompleteService, IFilterComplete } from '../../../../filter-complete/filter-complete';

@Component({
  selector: 'cash-desk-open-edit',
  templateUrl: './cash-desk-open-edit.component.html',
  styleUrls: ['./cash-desk-open-edit.component.css']
})
export class CashDeskOpenEditComponent implements OnInit {

  loadingAction: boolean;
  loading: boolean;
  cashDeskId: number;
  form: FormGroup;
  filterCompleteUser: FilterCompleteService<IFilterComplete>;

  constructor(private route: ActivatedRoute
    , private menuService: MenuService
    , private formBuilder: FormBuilder
    , private cashDeskService: CashDeskService
    , private notificationToastService: NotificationToastService) {
    this.menuService.setMenuTitle('Caja', 'Apertura');

    this.form = this.formBuilder.group({
      CashDeskName: [{ value: '', disabled: true }, [Validators.required]],
      CashDesk: ['', [Validators.required]],
      OpenAmount: [{ value: '', disabled: true }, [Validators.required]],
      UserFilter: [{ value: null }, [Validators.required, ValidateAutoCompleteSelect]]
    });

    this.filterCompleteUser = new FilterCompleteService<IFilterComplete>([], this.f.UserFilter);
  }

  get f() { return this.form.controls; }
  get filteredUserOptions() { return this.filterCompleteUser ? this.filterCompleteUser.filteredOptions : []; }

  async ngOnInit() {
    this.loading = true;
    this.route.params.subscribe(async params => {
      try {
        this.cashDeskId = params['CashDeskId'];
        const info = await this.cashDeskService.getCashDeskOpenEdit(this.cashDeskId);
        this.filterCompleteUser = new FilterCompleteService<IFilterComplete>(info.Users, this.f.UserFilter);
        this.form.patchValue({
          CashDeskName: info.CashDesk.Name
          , CashDesk: info.CashDesk
          , OpenAmount: info.CashDesk.OpenAmount
          , UserFilter: info.User });

      } catch (err) {
        this.notificationToastService.error(JSON.stringify(err.error), 'Caja');
      } finally {
        this.loading = false;
      }
    });
  }

  close(): void {
    history.back();
  }

  async open() {
    try {
      if (this.form.valid) {
        this.loadingAction = true;
        await this.cashDeskService.cashDeskOpen(this.f.UserFilter.value, this.f.CashDesk.value);
        this.close();
      }
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Caja');
    } finally {
      this.loadingAction = false;
    }
  }

}
